import { render } from "./manage-name.vue?vue&type=template&id=084e755c&scoped=true&ts=true"
import script from "./manage-name.vue?vue&type=script&lang=ts"
export * from "./manage-name.vue?vue&type=script&lang=ts"

import "./manage-name.vue?vue&type=style&index=0&id=084e755c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084e755c"]])

export default __exports__